<template>
    <div>
        <div v-if="isLoading" class="w-10 h-10 mt-20 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
        <div v-else class="-my-2 md:-mx-6 lg:-mx-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            
            <div class="col-span-1">
                <label class="px-2 text-lg sm:text-xl font-bold" for="year">
                    Program Year
                </label>
                <select 
                    name="year" 
                    id="year" 
                    class="py-2 pl-3 pr-10 mt-1 mb-4 text-md border-gray-300 rounded-md font-bold focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-lg"
                    v-model="year_index"
                    @change="updateYear"
                >
                    <option 
                    v-for="option in getDropDownOptions"
                    :value=option.value
                    >{{ option.label }}</option>
                </select>
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow">
                    <div class="px-4 py-5 sm:px-6">
                        <h1 class="text-lg font-bold">Payments</h1>
                    </div>
                    <div class="px-4 py-2 sm:p-2">
                        <apex-chart type="area" height='300' width='100%' class="justify-end"
                                :options="{
                                    chart: {
                                        toolbar: {
                                            show: false,
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    fill: {
                                        gradient: {
                                            enabled: true,
                                            opacityFrom: 0.55,
                                            opacityTo: 0
                                        }
                                    },
                                    stroke: {
                                      curve: 'smooth',
                                      width: 1.75,
                                    },
                                    xaxis: {
                                        categories: getLineChartSeries.labels
                                    },
                                    yaxis: {
                                        show: true,
                                        labels: {
                                            formatter: function(value) {
                                                var val = Math.abs(value)
                                                if (val >= 1000 && val <= 999999) {
                                                    val = (val / 1000).toFixed(0) + 'K'
                                                }
                                                if (val >= 1000000)
                                                {
                                                    val = (val / 1000000).toFixed(0) + 'M'
                                                }
                                                return '$'+val
                                            } 
                                        }
                                    },
                                    grid: {
                                        show: false,
                                    },
                                    
                                }"
                                :series="[{
                                    name: getLineChartSeries.name,
                                    data: getLineChartSeries.values
                                }]"
                        ></apex-chart>
                    </div>
                </div>
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow mt-4">
                    <div class="px-4 py-2 sm:px-6">
                        <h1 class="text-lg font-bold">Top 5 Manufacturers</h1>
                    </div>
                    <div class="py-2 sm:px-2">
                        <ul role="list" class="divide-y divide-gray-100">
                            <li v-for="manufacturer in topManufacturers()" class="relative py-5">
                                <div class="px-2 sm:px-2 lg:px-4">
                                <div class="mx-auto flex max-w-4xl justify-between gap-x-6">
                                    <div class="flex min-w-0 gap-x-4">
                                        <div class="min-w-0 flex-auto">
                                            <p class="text-sm font-semibold leading-6 text-gray-900">
                                            <div>
                                                <span class="absolute inset-x-0 -top-px bottom-0"></span>
                                                {{ manufacturer.name }}
                                            </div>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex shrink-0 items-center gap-x-4">
                                        <div class="hidden sm:flex sm:flex-col sm:items-end">
                                            <p class="text-md font-bold text-green-600 sm:text-lg">
                                                {{ moneyToString(manufacturer.current_total) }}
                                                <span v-if="manufacturer.current_total > manufacturer.last_year_total" class="inline-flex items-center gap-x-1 rounded-full bg-green-100 px-2 py-1 text-xxs text-green-700 ml-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941" />
                                                    </svg>
                                                    {{ Math.round(((manufacturer.current_total -  manufacturer.last_year_total)/manufacturer.current_total) * 100) }}%
                                                </span>
                                                <span v-else class="inline-flex items-center gap-x-1 rounded-full bg-red-100 px-2 py-1 text-xxs text-red-700 ml-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181" />
                                                    </svg>

                                                    {{ Math.round((( manufacturer.last_year_total - manufacturer.current_total)/manufacturer.last_year_total) * 100) }}%
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </li>   
                        </ul>
                    </div>
                </div>
                
            </div>
            <div class="col-span-1">
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow">
                    <div class="px-4 py-2 sm:px-6">
                        <h1 class="text-lg font-bold">Top 5 Products</h1>
                    </div>
                    <div class="py-2 sm:px-2">
                        <ul role="list" class="divide-y divide-gray-100">
                            <li v-for="products in topProducts()" class="relative py-5">
                                <div class="px-2 sm:px-2 lg:px-4">
                                <div class="mx-auto flex max-w-4xl justify-between gap-x-6">
                                    <div class="flex min-w-0 gap-x-4">
                                    <div class="min-w-0 flex-auto">
                                        <p class="text-sm font-semibold leading-6 text-gray-900">
                                        <div>
                                            <span class="absolute inset-x-0 -top-px bottom-0 font-semibold"></span>
                                            {{ products.key[0] }}
                                        </div>
                                        </p>
                                        <p class="mt-1 flex text-xs leading-5 text-gray-500">
                                            {{ products.key[1] }}
                                        </p>
                                    </div>
                                    </div>
                                    <div class="flex shrink-0 items-center gap-x-4">
                                    <div class="hidden sm:flex sm:flex-col sm:items-end">
                                        <p class="text-md font-bold text-green-600 sm:text-lg">
                                            {{ moneyToString(products.product_totals.value) }}
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </li>   
                        </ul>
                    </div>
                </div>
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow mt-4">
                    <div class="px-4 py-5 sm:px-6">
                        <h1 class="text-lg font-bold">Natures of Payment</h1>
                    </div>
                    <div class="px-4 py-2 sm:p-2">
                        <apex-chart type="donut" height='300' width='100%' class="justify-end"
                                :options="{
                                    chart: {
                                        toolbar: {
                                            show: false,
                                        }
                                    },
                                    plotOptions: {
                                        pie: {
                                            donut: {
                                                size: '80%'
                                            }
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    stroke: {
                                      lineCap: 'round',
                                    },
                                    legend: {
                                        position: 'right',
                                        formatter: function(value) {
                                                var val = value
                                                if (val.length > 20) {
                                                    val = val.substring(0, 20)+'...'
                                                }
                                                return val
                                            } 
                                    },
                                    grid: {
                                        show: false,
                                    },
                                    tooltip: {
                                        y: {
                                            formatter: function(value) {
                                                var val = Math.abs(value)
                                                
                                                return moneyToString(val)
                                            }
                                        }
                                    },
                                    labels: getPieChartSeries.labels
                                }"
                                :series="getPieChartSeries.values"
                        ></apex-chart>
                    </div>
                </div>
            </div>
            <div class="col-span-1 sm:col-span-2">
                <table class="min-w-full divide-y divide-gray-200 tw-table">
                    <thead class="bg-gray-50">
                        <tr>
                            <th scope="col"
                                class="w-1/5 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Company
                            </th>
                            <th scope="col"
                                class="w-1/5 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Nature of Payment
                            </th>
                            <th scope="col"
                                class="w-1/3 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Products
                            </th>
                            <th scope="col"
                                class="w-1/6 px-3 py-1 text-xs font-medium tracking-wider text-right text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Payment
                            </th>
                            <th scope="col"
                                class="w-1/3 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Year
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(payment, index) in this.allPayments"
                            :key="index"
                            :class="{
                                'bg-gray-100':index % 2 == 0
                            }
                            "
                        >
                            <td class="w-1/6 px-3 py-1 text-xs font-medium text-gray-500 align-middle md:text-sm md:px-6 md:py-2">
                                {{ payment._source.manufacturer_name }}
                            </td>
                            <td class="w-1/5 px-3 py-1 text-xs text-gray-500 align-middle md:text-sm md:px-6 md:py-2">
                                {{ payment._source.nature_of_payment }}
                            </td>
                            <td class="w-1/5 px-3 py-1 text-xs font-medium text-green-500 align-middle md:text-sm md:px-6 md:py-2">
                                <span 
                                    v-for="(product) in getProductArray(payment)"
                                    class="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">
                                    {{ product }}
                                </span>
                            </td>
                            <td class="w-1/6 px-3 py-1 text-xs font-medium text-right align-middle md:text-sm md:px-6 md:py-2">
                                {{ moneyToString(payment._source.total_payment) }}
                            </td>
                            <td class="w-1/6 px-3 py-1 text-xs text-gray-500 align-middle md:text-sm md:px-6 md:py-2">
                                {{ payment._source.year }}
                            </td>
                        </tr>
                    </tbody>
                    </table>
            </div>
        </div>
    </div>
</template>
<script>
    import VueApexCharts from 'vue-apexcharts';

    export default {
        props: {
            sunshineTableRoute: {
                type: String,
                required: true,
            }
        },
        computed: {
            getLineChartSeries () {
                var series = {
                    'labels':[],
                    'values':[],
                    'name':'Payment Total'
                };
                this.sunshineTableData.aggregations.aggs.buckets.forEach(
                    function (item) {
                        series.labels.unshift(item.key)
                        series.values.unshift(Math.round(item.year_totals.value))
                    }
                );
                
                return series;
            },
            getPieChartSeries () {
                
                var series = {
                    'labels':[],
                    'values':[],
                }
                
                this.sunshineTableData.aggregations.aggs.buckets[this.year_index].nature_of_payment.buckets.forEach(function (item) {
                    series.labels.unshift(item.key);
                    series.values.unshift(item.nature_totals.value)
                })
                
                return series;
            },
            getDropDownOptions() {
                var options = [];
                this.sunshineTableData.aggregations.aggs.buckets.forEach(
                    function (item, index) {
                        options.push({
                            'label': item.key,
                            'value': index
                        })
                    }
                );

                return options;
            }
        },
        data() {
            return{
                sunshineTableData: {},
                allPayments: [],
                isLoading: true,
                year_index: 0,
            }
        },
        created() {
            this.loadSunshineData();
        },
        methods: {
            async loadSunshineData() {
                try {
                    this.isLoading = true;
                    const response = await axios.get(this.sunshineTableRoute);
                    this.sunshineTableData = response.data;
                    this.allPayments = this.sunshineTableData.hits.hits[this.year_index].inner_hits.year_hits.hits.hits;
                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                    return false;
                }

                return true;
            },
            moneyToString( num ) {
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                return formatter.format(this.nullToZero(num));
            },
            nullToZero(num) {
                return num === null ? 0 : parseFloat(num);
            },
            productArray (products) {
                var arr = products.split(',');
                return arr.filter(element => {
                    return element !== '';
                });
            },
            topManufacturers () {
                var manufacturer_aggregations = this.sunshineTableData.aggregations.aggs.buckets[this.year_index].manufacturer_ids.buckets;
                
                var previous_year_manufacturer_aggregations = this.sunshineTableData.aggregations.aggs.buckets[parseInt(this.year_index) + 1].manufacturer_ids.buckets;
                
                var manufacturer_arr = [];
                manufacturer_aggregations.forEach(function(item) {
                    let obj = previous_year_manufacturer_aggregations.find(o => o.key[1] === item.key[1])
                    if (obj == null) {
                        obj = {'manufacturer_totals' : {'value': 0}}
                    }
                    
                    manufacturer_arr.push({'name':item.key[0], 'current_total':item.manufacturer_totals.value, 'last_year_total':obj.manufacturer_totals.value })
                })
                
                return manufacturer_arr.slice(0,5);
            },
            topProducts () {
                var product_aggregations = this.sunshineTableData.aggregations.aggs.buckets[this.year_index].product.buckets;


                return product_aggregations.slice(0,5);
            },
            getProductArray (payment) {
                var arr = [payment._source.product_1, payment._source.product_2,payment._source.product_3,payment._source.product_4,payment._source.product_5];
                var clean_arr = [];
                arr.forEach(function (item) {
                    if (item !== 'NA') {
                        if (item.length > 30) {
                            item = item.substring(0, 30)+'...'
                        }
                        clean_arr.push(item);
                    }
                })

                return clean_arr;
            },
            updateYear (e) {
                var val = e.target.value;
                this.year_index = val;
                this.loadSunshineData();
            }
        }
    }
</script>
